import { UseTranslationResponse, useTranslation } from 'react-i18next';

import { TranslationKeys, TranslationNS } from './TranslationKeys';
import { RequiredAny } from 'ui-kit/lib/types';

export type TKeys<T extends TranslationNS = 'common'> =
  | keyof TranslationKeys[T]
  | keyof TranslationKeys['common'];
export type TFunction<T extends TranslationNS> = (
  str: TKeys<T> | undefined | null,
  params?: RequiredAny
) => string;
export const useTranslate = <T extends TranslationNS>(ns: T) => {
  const { t, ready, i18n } = useTranslation(ns);
  return { t, ready, i18n } as {
    t: TFunction<T> & TFunction<'common'>;
    ready: boolean;
    i18n: UseTranslationResponse<RequiredAny>['i18n'];
  };
};
